export default __webpack_public_path__ + "static/media/1.f274aa3f.jpg";